module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/vegamagic.5427004.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/vegamagic.jpg
// module id = 0YmC
// module chunks = 0